export default __webpack_public_path__ + "static/media/background-bottom.77dd5067.svg";